var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.editOpened
      ? _c("div", { staticClass: "flex flex-col" }, [
          _c(
            "div",
            {
              staticClass:
                "py-4 px-6 flex items-center justify-between border-b border-slate-400"
            },
            [
              _c("BlTextSubtitle2", {
                staticClass: "text-slate-700",
                attrs: { text: "Report details" }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("BlInputButton", {
                    attrs: { label: "Edit", type: "outlined", dense: "" },
                    on: {
                      clicked: function($event) {
                        _vm.editOpened = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlIcon", {
                    staticClass: "h-6 w-6",
                    attrs: { icon: "close", clickable: "" },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "py-4 px-6 flex flex-col gap-3" }, [
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c("BlTextBody3", { attrs: { text: "Report name" } }),
                _vm._v(" "),
                _c("BlTextSubtitle3", { attrs: { text: _vm.report.name } })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "h-0.5 w-full flex-shrink-0 bg-slate-200 rounded"
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c("BlTextBody3", { attrs: { text: "Date range" } }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlTextSubtitle3", {
                      attrs: {
                        text: _vm.displayDate({ date: _vm.report.start_date })
                      }
                    }),
                    _vm._v(" "),
                    _c("BlTextSubtitle3", { attrs: { text: " - " } }),
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      attrs: {
                        text: _vm.displayDate({ date: _vm.report.end_date })
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "h-0.5 w-full flex-shrink-0 bg-slate-200 rounded"
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c("BlTextBody3", {
                  attrs: { text: "Include header in report" }
                }),
                _vm._v(" "),
                _c("BlTextSubtitle3", {
                  attrs: { text: _vm.report.include_header ? "Yes" : "No" }
                })
              ],
              1
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.editOpened
      ? _c("div", { staticClass: "flex flex-col" }, [
          _c(
            "div",
            {
              staticClass:
                "py-4 px-6 flex items-center justify-between border-b border-slate-400"
            },
            [
              _c("BlTextSubtitle2", {
                staticClass: "text-slate-700",
                attrs: { text: "Edit report details" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "py-4 px-6 flex flex-col gap-3" }, [
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c("BlTextSubtitle3", { attrs: { text: "Report name" } }),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "You can change the report name here, and this will be reflected as the title in the report."
                  }
                }),
                _vm._v(" "),
                _c("BlInputText", {
                  attrs: { input: _vm.nameInput },
                  on: { changed: _vm.inputHandler }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "h-0.5 w-full flex-shrink-0 bg-slate-200 rounded"
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c("BlTextSubtitle3", { attrs: { text: "Date range" } }),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "Adjust the date range here to apply it to any new graphs you add. This will not change the date range of existing graphs already included in the report."
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-4" },
                  [
                    _c("BlInputDate", {
                      attrs: { input: _vm.startDateInput },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c("BlInputDate", {
                      attrs: { input: _vm.endDateInput },
                      on: { changed: _vm.inputHandler }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "h-0.5 w-full flex-shrink-0 bg-slate-200 rounded"
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center justify-between" },
                  [
                    _c("BlTextSubtitle3", {
                      attrs: { text: "Include header in report" }
                    }),
                    _vm._v(" "),
                    _c("BlInputToggle", {
                      attrs: { checked: _vm.includeHeaderInput },
                      on: {
                        changed: function($event) {
                          _vm.includeHeaderInput = !_vm.includeHeaderInput
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "The header is included by default when the report is generated as a PDF. You can switch off the toggle to remove it from the PDF."
                  }
                }),
                _vm._v(" "),
                _vm.currentUser.role.includes("admin")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "py-2 flex items-center justify-center gap-1 rounded bg-cornflower-200"
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-cornflower-800 flex-wrap",
                          attrs: {
                            text: "To adjust the logo or center name, visit"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "flex items-center gap-1",
                            attrs: { to: "/center", target: "_blank" }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass:
                                "text-cornflower-800 flex-wrap font-bold underline",
                              attrs: { text: "Center Settings!" }
                            }),
                            _vm._v(" "),
                            _c("BlIcon", {
                              staticClass: "h-4 w-4",
                              attrs: {
                                icon: "square-up",
                                color: "cornflower-8"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "py-2 px-2 rounded bg-cornflower-200" },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-cornflower-800 flex-wrap",
                          attrs: {
                            text:
                              "To adjust the logo or center name, ask an Admin to change it in "
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass:
                            "text-cornflower-800 flex-wrap font-bold",
                          attrs: { text: "Center Settings." }
                        })
                      ],
                      1
                    )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "py-4 px-6 grid grid-cols-2 items-center gap-4" },
            [
              _c("BlInputButton", {
                attrs: { label: "Cancel", type: "plain" },
                on: {
                  clicked: function($event) {
                    _vm.editOpened = false
                  }
                }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: { label: "Update", loading: _vm.updateLoading },
                on: { clicked: _vm.onUpdate }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f0431af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f0431af","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/helper/Setting.vue
// module id = null
// module chunks = 